import { render, staticRenderFns } from "./bdHeader.vue?vue&type=template&id=0812e6fe&scoped=true"
import script from "./bdHeader.vue?vue&type=script&lang=js"
export * from "./bdHeader.vue?vue&type=script&lang=js"
import style0 from "./bdHeader.vue?vue&type=style&index=0&id=0812e6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0812e6fe",
  null
  
)

export default component.exports